import * as Type from './types'

export function populate(data, callback = null) {
    return {
        type: Type.POPULATE,
        data: data,
        callback: callback
    }
}

export function setStep(step, callback = null)
{
    return {
        type: Type.SET_STEP,
        data: step,
        callback: callback
    }
}

export function setMode(mode, callback = null)
{
    return {
        type: Type.SET_MODE,
        data: mode,
        callback: callback
    }
}

export function setInProgress(status = true, callback = null)
{
    return {
        type: Type.SET_IN_PROGRESS,
        data: status,
        callback: callback
    }
}

export function displayFooter(display = true, callback = null)
{
    return {
        type: Type.SET_DISPLAY_FOOTER,
        data: display,
        callback: callback
    }
}

export function setLogs(data, mode, callback = null)
{
    return {
        type: Type.SET_LOGS,
        data: data,
        mode: mode,
        callback: callback
    }
}

export function setInterLzs(data, callback = null)
{
    return {
        type: Type.SET_INTERLZS,
        data: data,
        callback: callback
    }
}

export function setDefaultRoutes(data, callback = null)
{
    return {
        type: Type.SET_DEFAULT_ROUTES,
        data: data,
        callback: callback
    }
}

export function setSelected(data, callback = null)
{
    return {
        type: Type.SET_SELECTED,
        data: data,
        callback: callback
    }
}

export function setLoaded(value = null, callback = null) {
    return {
        type: Type.SET_LOADED,
        data: value,
        callback: callback
    }
}